import { Component, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import * as moment from "moment-timezone";
import { AlertService } from "../../../shared/alert/services/alert.service";
import { AssetsService } from "../../../shared/services/assets.service";
import { SideBarService } from "../../../shared/services/sideBarService";
import { UrlService } from "../../../shared/services/url.service";
import { TradePlan } from "../../models/TradePlan";
import { SignalsConfigurationService } from "../../services/signalsconfiguration.service";
import { TradePlanService } from "../../services/tradePlan.service";
import { ConfirmationModalComponent } from "./confirmationModal.component";
import { SignalsMainComponent } from "./main.component";
import { SignalsDeleteModalComponent } from "./signalsDeleteModal.component";
import { ValidationsService } from "../../services/validations.service";

@Component({
  selector: "app-signals-tradeplans",
  templateUrl: "../templates/signalsTradePlans.component.html",
})
@Injectable()
export class SignalsTradePlansComponent extends SignalsMainComponent {
  private DashboardUrl = "";
  private inProgress = true;
  private sideValues = [
    { value: "BUY", text: "Buy" },
    { value: "SELL", text: "Sell" },
  ];
  private marketPriceIndicatorValues = [
    { value: false, text: "Above" },
    { value: true, text: "Below" },
  ];

  private dialogStyle = {
    hasBackdrop: true,
    backdropClass: "fxstreet-modal-backdrop",
    panelClass: "fxstreet-message-dialog-panel",
    position: { top: "150px" },
  };

  private TradePlans: TradePlan[] = [];
  private tradePlan: TradePlan;
  private Assets = [];
  private Servers = [];

  private readonly CREATE = "Create";
  private readonly UPDATE = "Update";

  constructor(
    private urlService: UrlService,
    private alertService: AlertService,
    private assetsService: AssetsService,
    private configuration: SignalsConfigurationService,
    private dialog: MatDialog,
    private tradePlanService: TradePlanService,
    private validationsService: ValidationsService,
    sidebarService: SideBarService
  ) {
    super(sidebarService);
    this.tradePlan = this.createEmptyTradePlan();
  }

  ngOnInit() {
    super.ngOnInit();
    this.Init();
  }

  async Init(): Promise<void> {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.assetsService
      .GetByFilter({
        name: "",
        providerId: this.configuration.GetQbitiaAssetProviderId(),
        type: "",
        isFollow: "",
        providerCode: "",
      })
      .subscribe(
        (result) =>
        (this.Assets = result.Assets.sort((a, b) =>
          a.Name > b.Name ? 1 : b.Name > a.Name ? -1 : 0
        ))
      );
    await this.loadTrades();
  }

  private async loadTrades() {
    try {
      const response = await this.tradePlanService.Get().toPromise();

      if (response) {
        this.TradePlans = response;
        this.sortAscByDate(this.TradePlans);
      }
    } catch (error) {
      this.TradePlans = [];
    }
  }

  private createEmptyTradePlan(): TradePlan {
    const tradePlan: TradePlan = {
      id: "",
      dateUtc: moment.utc(),
      symbol: "",
      side: "",
      takeProfit: null,
      stopLoss: null,
      entryPrice: null,
      insightsQuery: "Trade Plan",
      state: "OPEN",
      belowMarketPrice: false
    };
    return tradePlan;
  }

  private saveTrade(tradePlan: TradePlan, action: "Create" | "Update"): void {
    this.alertService.removeAll();
    if (this.isValidTradePlan(tradePlan)) {
      tradePlan.symbol = tradePlan.symbol.toUpperCase();
      tradePlan.dateUtc = moment.utc();
      this.dialog
        .open(ConfirmationModalComponent, {
          ...this.dialogStyle,
          data: {
            details: tradePlan,
            title: `${action} Trade Plan`,
            message: `Are you sure you want to ${action.toLowerCase()} this trade plan?`,
          },
        })
        .afterClosed()
        .subscribe((shouldSave) => {
          if (shouldSave) {
            this.inProgress = true;
            this.tradePlanService[action](tradePlan).subscribe((response) => {
              this.inProgress = false;
              if (response) {
                if (action === this.CREATE) {
                  this.loadTrades();
                }
                this.alertService.add(
                  "success",
                  `Trade Plan successfully ${action.toLowerCase()}`
                );
              }
            });
            this.tradePlan = this.createEmptyTradePlan();
          }
        });
    }
  }

  private CreateTrade(tradePlan: TradePlan): void {
    this.saveTrade(tradePlan, this.CREATE);
  }

  private UpdateTrade(tradePlan: TradePlan): void {
    this.saveTrade(tradePlan, this.UPDATE);
  }

  private DeleteTrade(tradePlan: TradePlan): void {
    this.dialog
      .open(SignalsDeleteModalComponent, {
        ...this.dialogStyle,
        data: { message: null, isScheduled: false, tradePlan: tradePlan },
      })
      .afterClosed()
      .subscribe(() => {
        this.loadTrades();
        this.alertService.add("success", "Trade Plan deleted successfully");
      });
  }

  private isValidTradePlan(tradePlan: TradePlan): boolean {
    var result = true;

    if (this.isNullOrWhiteSpace(tradePlan.side)) {
      this.alertService.add("danger", "Please select a Side");
      result = false;
    }
    if (this.isNullOrWhiteSpace(tradePlan.symbol)) {
      this.alertService.add("danger", "Please select a Instrument");
      result = false;
    }
    if (this.isNullOrWhiteSpace(tradePlan.entryPrice ? tradePlan.entryPrice.toString() : null)) {
      this.alertService.add("danger", "Please select a Entry Price");
      result = false;
    }
    if (
      this.validationsService.hasInvalidLimits(
        tradePlan.side,
        tradePlan.stopLoss,
        tradePlan.takeProfit,
        tradePlan.entryPrice
      )
    ) {
      this.alertService.add(
        "danger",
        "Please check EntryPrice, TakeProfit and StopLoss values. Some of them are invalid."
      );
      result = false;
    }

    return result;
  }

  private isNullOrWhiteSpace(value: string): boolean {
    return value && value.trim() ? false : true;
  }

  private sortAscByDate(array: TradePlan[]) {
    array.sort((a: TradePlan, b: TradePlan) => a.dateUtc - b.dateUtc);
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsTradePlan.component.ts